import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Building2, Loader2, ShieldCheck } from "lucide-react";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/dashboard", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Willkommen zurück");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || "Anmeldung fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 relative overflow-hidden">
      <div className="absolute inset-0 opacity-40"
        style={{ background: "radial-gradient(60% 50% at 50% 0%, rgba(37,99,235,0.18), transparent)" }} />
      <div className="w-full max-w-md relative fade-in">
        <div className="flex flex-col items-center mb-8">
          <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary text-primary-foreground mb-4 shadow-lg shadow-primary/30">
            <Building2 className="h-7 w-7" />
          </div>
          <h1 className="text-2xl font-bold tracking-tight">WebDesign Damerow</h1>
          <p className="text-sm text-muted-foreground mt-1">Internes Sales CRM · geschützter Bereich</p>
        </div>

        <form onSubmit={submit}
          className="rounded-2xl border border-border bg-card p-6 sm:p-8 shadow-xl space-y-5">
          <div>
            <Label>E-Mail</Label>
            <Input data-testid="login-email" type="email" autoComplete="username" value={email}
              onChange={(e) => setEmail(e.target.value)} placeholder="name@webdesign-damerow.de" required />
          </div>
          <div>
            <Label>Passwort</Label>
            <Input data-testid="login-password" type="password" autoComplete="current-password" value={password}
              onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required />
          </div>
          {error && (
            <div data-testid="login-error" className="rounded-lg bg-destructive/15 border border-destructive/30 px-3 py-2 text-sm text-red-300">
              {error}
            </div>
          )}
          <Button type="submit" data-testid="login-submit" className="w-full" disabled={loading}>
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Anmelden
          </Button>
          <div className="flex items-center justify-center gap-1.5 text-xs text-muted-foreground pt-1">
            <ShieldCheck className="h-3.5 w-3.5" /> Verschlüsselte Sitzung · nur für autorisierte Nutzer
          </div>
        </form>
      </div>
    </div>
  );
}
